<template>
    <div>
        <div class="holder">
            <div class="contianer-fluid">
                <div class="row">
                    <div class="col-md-8">
                        <!-- <p @click="backBtn()" class="back-text"><span><i class="fa fa-chevron-left"></i></span>Back</p> -->
                        <div class="m-auto text-center mt-4" v-if="loading">
                            <Loader />
                        </div>
                        <div v-if="property.length == 0 && !loading">
                            <EmptyState :emptyData="emptyDataObject" />
                        </div>

                        <div class="left-holder">
                            <div class="prop-title">
                                <h3>{{ property.title }}</h3>
                                <h6>{{ property.batch }}</h6>
                                <p>{{ property.address }}</p>
                            </div>
                            <div class="mb-5">
                                <hr>
                                <div class="d-flex text-header-container">
                                    <h4 class="text-header">Units</h4>
                                    <button class="btn-primary py-2 requestBtn" @click="openMaintenanceModal">
                                        <!-- <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M9.9974 18.3307C14.5807 18.3307 18.3307 14.5807 18.3307 9.9974C18.3307 5.41406 14.5807 1.66406 9.9974 1.66406C5.41406 1.66406 1.66406 5.41406 1.66406 9.9974C1.66406 14.5807 5.41406 18.3307 9.9974 18.3307Z"
                                                stroke="white" stroke-width="1.6" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M6.66406 10H13.3307" stroke="white" stroke-width="1.6"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M10 13.3307V6.66406" stroke="white" stroke-width="1.6"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg> -->

                                        <span>
                                            New Maintenance Request
                                        </span>
                                    </button>

                                </div>


                                <div class="unit-holder">
                                    <div class="search-holder d-none">
                                        <div class="form-group d-flex justify-content-between">
                                            <input class="form-control input-field search" type="text" name="search"
                                                id="search" placeholder="Search by tenant name">
                                            <button class="btn clear-btn">Clear all</button>
                                        </div>

                                        <div>
                                            <div class="form-group">
                                                <select class="form-control select-stack">
                                                    <option>Guaranteed</option>
                                                    <!-- <option>Option 1</option>
                                                <option>Option 2</option> -->
                                                </select>

                                                <select class="form-control select-stack">
                                                    <option>Due in 30 days</option>
                                                    <!-- <option>Option 1</option>
                                                <option>Option 2</option> -->
                                                </select>

                                                <select class="form-control select-stack">
                                                    <option>Occupied</option>
                                                    <!-- <option>Option 1</option>
                                                <option>Option 2</option> -->
                                                </select>
                                            </div>
                                        </div>


                                    </div>
                                    <!-- <hr> -->
                                    <div class="table-responsive tableList">

                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Unit name</th>
                                                    <th scope="col">Tenant name</th>
                                                    <th scope="col">Rent type</th>
                                                    <th scope="col">Next rent due</th>
                                                    <th scope="col">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="!loading && units.length != 0">
                                                <tr v-for="(item, index) in units" :key="index"
                                                    @click="moveToUnitDetails(item.id)">
                                                    <td>{{ item.nomenclature_serial }}</td>

                                                    <td
                                                        v-if="item.rent_status == 'pending verification' && item.awaiting_tenant">
                                                        {{ item.awaiting_tenant }}</td>
                                                    <td
                                                        v-if="item.rent_status != 'pending verification' && item.rent_status != 'vacant'">
                                                        {{ item.tenant }}</td>
                                                    <td
                                                        v-if="item.rent_status == 'vacant' && item.awaiting_tenant == null">
                                                        --</td>
                                                    <td>{{ property.typename }}</td>
                                                    <td>{{ item.next_rent_due | moment }}</td>
                                                    <td style="text-transform: capitalize;"><span class=""
                                                            :class="[item.rent_status == 'occupied' ? 'occupied' : '', item.rent_status == 'vacant' ? 'vacant' : '', item.rent_status == 'pending verification' ? 'pending' : '']">{{
                                                            item.rent_status }}</span></td>
                                                </tr>
                                                <!-- <tr>
                                                <td>1A</td>
                                                <td>Jacob Jones</td>
                                                <td>Harmonized</td>
                                                <td>March 5, 2015</td>
                                                <td><span class="vacant">Vacant</span></td>
                                            </tr> -->
                                                <!-- <tr v-for="(item, index) in assingedFMArray"
                                                :key="index"
                                                :value="item.id">
                                                <td>{{index + 1}}</td>
                                                <td>{{item.user.firstname}} {{item.user.lastname}}</td>
                                                <td>{{item.user.email}}</td>
                                                <td>{{item.user.phone}}</td>
                                                <td>{{ item.user.address }}</td>
                                            </tr> -->

                                            </tbody>
                                        </table>
                                        <div class="m-auto text-center mt-4" v-if="loading">
                                            <Loader />
                                        </div>
                                        <div v-if="units.length == 0 && !loading">
                                            <EmptyState :emptyData="emptyDataObject2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <hr> -->
                            <h4 v-if="property.description" class="text-header">About this property</h4>
                            <div class="about-prop">
                                <p>{{ property.description }}</p>
                                <!-- <small>See more</small> -->
                            </div>
                            <hr v-if="property.description">
                            <div>
                                <div class="d-flex justify-content-between" @click="showOverview = !showOverview"
                                    style="cursor: pointer;">
                                    <h4 class="text-header">Property overview</h4>

                                    <span style="cursor: pointer;" @click="showOverview = !showOverview"><i class="fa"
                                            :class="[showOverview ? 'fa-chevron-up' : 'fa-chevron-down']"></i></span>
                                </div>
                                <div class="row mt-3" v-if="showOverview">
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Property type</h6>
                                            <h5>{{ property.typename }}</h5>
                                        </div>
                                    </div>

                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Property subtype</h6>
                                            <h5>{{ property.subtypename }}</h5>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Business type</h6>
                                            <h5>{{ property.businesstypename }}</h5>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Units</h6>
                                            <h5>{{ property.units }}</h5>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>State</h6>
                                            <h5>{{ property.state }}</h5>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>City</h6>
                                            <h5>{{ property.city }}</h5>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                            </div>
                            <div>
                                <div class="d-flex justify-content-between" @click="showLandlord = !showLandlord"
                                    style="cursor: pointer;">
                                    <h4 class="text-header">Landlord’s contact info</h4>

                                    <span style="cursor: pointer;" @click="showLandlord = !showLandlord"><i class="fa"
                                            :class="[showLandlord ? 'fa-chevron-up' : 'fa-chevron-down']"></i></span>
                                </div>
                                <div class="row mt-3" v-if="showLandlord">
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Landlord name</h6>
                                            <h5>{{ property.landlord.firstname }} {{ property.landlord.lastname }}</h5>
                                        </div>
                                    </div>

                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Email address</h6>
                                            <h5>{{ property.landlord.email }}</h5>
                                        </div>
                                    </div>

                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Phone number</h6>
                                            <h5>{{ property.landlord.phone }}</h5>
                                        </div>
                                    </div>
                                </div>
                                <hr>


                            </div>

                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="right-holder">
                            <h4 class="text-header">Rent disbursement history</h4>
                            <hr>
                            <div class="m-auto text-center mt-4" v-if="loading">
                                <Loader />
                            </div>
                            <div class="" v-for="(item, index) in rentDisbursment" :key="index">
                                <div class="disbursement-items">
                                    <div>
                                        <h4>Unit {{ item.unit_name }}</h4>
                                        <h5>Disbursed: ₦{{ Number(item.amount).toLocaleString() }}</h5>
                                    </div>
                                    <h6>{{ item.date | moment }}</h6>
                                </div>
                                <hr>
                            </div>
                            <div v-if="rentDisbursment.length == 0 && !loading">
                                <EmptyState :emptyData="emptyDataObject3" />
                            </div>


                            <h4 class="text-header mt-5">Assigned team</h4>
                            <hr>
                            <div class="m-auto text-center mt-4" v-if="loading">
                                <Loader />
                            </div>
                            <div
                                v-if="property.facility_manager == null && property.inspection_officer == null && !loading">
                                <EmptyState :emptyData="emptyDataObject4" />
                            </div>
                            <div>
                                <div class="profile-container" v-if="facilityManager">
                                    <!-- <img src="../assets//images/profile.png" alt="Profile Picture" class="profile-pic"> -->
                                    <img src="@/assets/profileImage.jpg" alt="profile pic" class="profile-pic">
                                    <div class="profile-info">
                                        <h3>{{ facilityManager.firstname }} {{ facilityManager.lastname }}</h3>
                                        <p>{{ facilityManager.email }}</p>
                                        <p>{{ facilityManager.phone }}</p>
                                        <p>Facility manager</p>
                                    </div>
                                </div>
                                <div class="profile-container" v-if="inspectionOfficer">
                                    <img src="@/assets/profileImage.jpg" alt="Profile Picture" class="profile-pic">
                                    <div class="profile-info">
                                        <h3>{{ inspectionOfficer.firstname }} {{ inspectionOfficer.lastname }}</h3>
                                        <p>{{ inspectionOfficer.email }}</p>
                                        <p>{{ inspectionOfficer.phone }}</p>
                                        <p>Inspection officer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Maintenance Request Modal -->
        <MaintenanceRequest v-if="property" :isOpen="isModalOpen" @close="closeMaintenanceModal" @callFunction="refreshApp" :propertyData="units" />
    </div>
</template>

<script>
import properties from "../services/properties";
import Loader from '../components/Loader';
import EmptyState from "../components/EmptyState.vue";
import moment from 'moment';
import MaintenanceRequest from "./MaintenanceRequest.vue";
export default {
    name: "PropertyDetails",
    components: {
        Loader,
        EmptyState,
        MaintenanceRequest
    },
    data() {
        return {
            loading: false,
            activeTab: 1,
            showOverview: false,
            showLandlord: false,
            batch: "",
            // sub: "",
            rentDisbursment: [],
            property: '',
            units: [],
            inspectionOfficer: '',
            facilityManager: "",
            emptyDataObject: {
                header: 'No record found',
                option: 'No property details found for this property'
            },
            emptyDataObject2: {
                header: 'No record found',
                option: 'No Unit for this property'
            },
            emptyDataObject3: {
                header: 'No record found',
                option: 'No rent disbursement for this property.'
            },
            emptyDataObject4: {
                header: 'No record found',
                option: 'No assigned team yet.'
            },
            isModalOpen: false

        }
    },
    created() {
        this.batch = this.$route.params.id;
    },
    mounted() {
        this.fetchPropertyByBatch();
    },
    methods: {
        // callChildMethod() {
        //   this.$refs.myChild.childFunction();
        // },
        refreshApp() {
            this.fetchPropertyByBatch();
        },
        backBtn() {
            this.$router.push({ path: `/user/partner/property-management` });
            // this.$router.go(-1)
        },
        moveToUnitDetails(batch) {
            // console.log("Unit details")
            this.$router.push({ path: `/user/partner/unit-details/${batch}` });
        },
        async fetchPropertyByBatch() {
            this.loading = true;
            try {
                await properties.fetchPropertiesByBatch(this.batch).then(res => {
                    // console.log("Properties", res);
                    this.loading = false;
                    if (res.success) {
                        this.property = res.property[0];
                        this.rentDisbursment = res.rent_disbursment;
                        this.facilityManager = res.property[0].facility_manager;
                        this.inspectionOfficer = res.property[0].inspection_officer;
                        this.units = res.units;
                        // console.log ("prop units", this.units)
                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }

                }).catch((err) => {
                    this.loading = false;
                    console.log(err);
                    // this.$toast.error("please check your network and refresh the page");
                })
            } finally {
                // console.log("closed")
            }
        },

        openMaintenanceModal() {
            this.isModalOpen = true;
        },
        closeMaintenanceModal() {
            this.isModalOpen = false;
        }
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY');
        }
        // moment: function(date) {
        //   return moment(date).format('MMMM DD YYYY, h:mm:ss a');
        // }
    },
    immediate: true
}
</script>

<style scoped lang="scss">
.holder {
    background: #ffffff;
    padding: 30px 15px;
}

.back-text {
    font-family: Lato;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #535862;
    margin-bottom: 20px !important;
    cursor: pointer;

    span {
        padding-right: 10px;
    }
}


.prop-title {

    h3,
    span {
        font-family: Lato;
        font-size: 24px;
        color: #2B3352;
    }

    h3 {
        font-weight: 600;
    }

    h6 {
        font-weight: 400;
        font-family: Lato;
        font-size: 20px;
        color: #2B3352;
    }

    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #555C74;
    }
}


.text-header {
    font-family: Lato;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: #2B3352;
}

.text-header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    button {
        background: #0033EA;
        border-radius: 8px;
        padding: 12px 18px;
    }
}

.about-prop {
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #555C74;
        margin-bottom: 20px !important;
    }

    small {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #0033EA;
        padding-top: 20px;
    }
}

.overview-data {
    margin-bottom: 30px;

    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        color: #555C74;
    }

    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #2B3352;
    }
}

.requestBtn {
    font-size: 14px;
}

.input-field {
    height: 48px;
    outline: 0;
    box-shadow: none;
}

.search {
    width: 50%;
    border-radius: 8px;
}

.clear-btn {
    border: 1px solid #D5D7DA;
    color: #414651;
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
    outline: 0;
    box-shadow: none;
}

.unit-holder {
    border: 1px solid #E9EAEB;
    border-radius: 12px;
}

.search-holder {
    padding: 20px;
}

input,
select {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    color: #414651;
}

.select-stack {
    display: inline-block;
    width: calc(25.33% - 10px);
    /* Show in a row on larger screens */
    margin-right: 5px;
    border-radius: 8px;
    outline: 0;
    box-shadow: none;
}

.table-responsive {
    margin-bottom: 0 !important;
}

.tableList {
    // margin-top: 30px;
    // margin-bottom: 20px;
    // border: 2px solid #EAECF0;
    // border-radius: 20px;
    // border-bottom: 0;
}


.table thead th {
    border-bottom: none;

}

.table td {
    border-top: 1px solid #EAECF0;
}

.table th {
    border-top: none;
}

thead>tr {
    // background: #EAECF0;
    background: #E9EAEB;
    cursor: pointer;
}

thead th {
    white-space: nowrap;
    font-family: Lato;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    // color: #667085
    color: #555C74;
}

tbody td {
    padding: 18px .75rem;
    white-space: nowrap;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #555C74;
    // color: #667085
}

tr {
    cursor: pointer;
}

.occupied {
    color: #B42318;
    font-family: Lato;
    font-weight: 500;
    font-size: 11px;
    background: #FEF3F2;
    border: 1px solid #FECDCA;
    border-radius: 50px;
    padding: 2px 6px;

}

.vacant {
    color: #067647;
    font-family: Lato;
    font-weight: 500;
    font-size: 11px;
    background: #ECFDF3;
    border: 1px solid #ABEFC6;
    border-radius: 50px;
    padding: 2px 6px;
}

.pending {
    // #555C74;

    color: #555C74;
    font-family: Lato;
    font-weight: 500;
    font-size: 11px;
    background: #f4f7fc;
    border: 1px solid #9a9ca0;
    border-radius: 50px;
    padding: 2px 6px;
}



.right-holder {
    border-left: 1px solid #E9EAEB;
    padding-left: 15px;
}

.disbursement-items {
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    h4,
    h5 {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
    }

    h4 {
        font-weight: 500;
        color: #2B3352;
    }

    h5 {
        font-weight: 400;
        color: #555C74;
    }
}

.profile-container {
    display: flex;
    align-items: flex-start;
    background: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    max-width: 400px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;
}

.profile-pic {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 15px;
}

.profile-info {
    flex: 1;
}

.profile-info h3 {
    margin: 0;
    font-size: 18px;
    font-family: Lato;
}

.profile-info p {
    margin: 3px 0;
    font-size: 14px;
    color: #555;
    font-family: Lato;
}

@media (max-width: 768px) {
    .select-stack {
        display: block;
        width: 100%;
        /* Stack on smaller screens */
        margin-bottom: 10px;
    }
}

@media screen and (max-width: 599px) {
    .search {
        width: 63%;
    }

    .right-holder {
        margin-top: 40px;
        border-left: none;
        padding-left: none
    }

    .text-header-container {
   flex-direction: column;
   align-items: flex-start;
}
}
</style>